import { ValidatorFn } from '@angular/forms';
import { isEmptyString } from '@web/utils';
import { ValidationError } from '../enums/validation-error';

export class PostCodeValidator {
  public static postCode = ((): ValidatorFn => {
    const regExp = /^\d{2}-\d{3}$/;

    return (control) => {
      const { value } = control;

      if (isEmptyString(value)) {
        return null;
      }

      if (regExp.test(value)) {
        return null;
      }

      return {
        [ValidationError.PostCode]: true,
      };
    };
  })();
}
